import { getProviderName } from "./providers/getProviderName";
import { ProviderType } from "@/services/cloudchipr.api";

export const accountInfoDrawerContent = (provider: ProviderType) => {
  const providerName = getProviderName(provider, { title: true });

  return [
    {
      title: "Tracked resources",
      children: [
        "Cloudchipr collects resource metadata every 15 minutes for all available accounts.",
        "Our list of cloud provider services includes only the most commonly used services as defined by the industry.",
        "The cost is forecasted based on previous usage; if billing data is unavailable, the cost is estimated using listing price and then converted into a monthly value.",
      ],
    },
    {
      title: "Underutilized resources",
      children: [
        "Displays the forecasted end-of-month cost of all resources identified as underutilized based on the applied utilization policy",
        "Cloudchipr provides default utilization policies tailored to each resource type.",
        "Users have the flexibility to define their own utilization policies according to their specific requirements.",
      ],
    },
    {
      title: "Tracked total",
      children: [
        "The forecasted end-of-month cost for all the resources currently being monitored.",
      ],
    },
    {
      title: "Trends",
      children: [
        "Trends display a monthly comparison of billing data as of today, compared to the same period in the previous month.",
      ],
    },
    {
      title: `${providerName} charge as of last month`,
      children: [
        `This represents the costs collected from ${providerName} billing as the total amount billed for a specific account.`,
      ],
    },
  ];
};
